module.exports = __webpack_public_path__ + "static/media/save.bf478683.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toolbar/icons/save.svg
// module id = 913
// module chunks = 53